import { render, staticRenderFns } from "./ShowVocalAudiometry.vue?vue&type=template&id=87cfaf26"
import script from "./ShowVocalAudiometry.vue?vue&type=script&lang=js"
export * from "./ShowVocalAudiometry.vue?vue&type=script&lang=js"
import style0 from "./ShowVocalAudiometry.vue?vue&type=style&index=0&id=87cfaf26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports